export default __webpack_public_path__ + "locales/ro/ResetApplicationDialog.json?hash=8053d487edf3c44ec618b546ed5e393c";